export default __webpack_public_path__ + "static/media/sistema_vexado_queroumaagencia-300x171 (1).647dc60e.png";